import React, { useState } from 'react';
import { Card, Panel, Table } from '@/components/Bicester';
import { ColumnConfig } from '@/components/Bicester/Table';
import { Alert } from 'rsuite';
import { FormikProvider, useFormik } from 'formik';
import { defaultInfo } from './constants';
import { Form } from '@/components/formik-rsuite';
import { IconButton } from 'rsuite';
import Image from '@/components/Bicester/Image';
import useContentHeight from '@/hooks/useContentHeight';
import { UserNameCell, Cell } from '@/components/Bicester/Table/Cells';
import { usePersistFn, useRequest } from 'ahooks';
import { InsideCell } from './Cell';
import { fetchList, fetchCheckIn } from '@/services/subscribe/sa';
import { Bicester } from '@/constants';
import _ from 'lodash';
import { useTable } from '@/hooks';
import { DEFAULT_TABLE_VALUE } from '@/constants/config';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { SERVICE_STATUS } from '@/services/constants';
import { LAYOUT_CONFIG } from '@/constants/layoutConfig';

const Sa = () => {
  const { profile } = useReadyInfo();

  const [data, setData] = useState([]);

  const {
    run: fetchTables,
    data: { current_page, total },
    loading: getListLoading,
  } = useRequest<typeof DEFAULT_TABLE_VALUE>(fetchList, {
    defaultParams: _.omit(_.pickBy(defaultInfo), 'time_range'),
    initialData: DEFAULT_TABLE_VALUE,
    onSuccess: (res) => setData(res.content_list),
  });

  const { onChange, onSearch, onRefresh } = useTable(fetchTables, {
    start_at: defaultInfo.time_range[0],
    end_at: defaultInfo.time_range[1],
  });

  const formik = useFormik({
    initialValues: defaultInfo,
    enableReinitialize: true,
    onSubmit(values) {
      const { time_range = [], ...rest } = values;
      const params = {
        ...rest,
        start_at: time_range[0] || '',
        end_at: time_range[1] || '',
      };
      onSearch(_.pickBy(params));
    },
  });

  const insideHandle = usePersistFn(async (rowData) => {
    const { status } = await fetchCheckIn({ id: rowData?.id });
    if (status === SERVICE_STATUS.SUCCESS) {
      onRefresh();
      Alert.success('入场成功');
    }
  });

  const columns: ColumnConfig[] = [
    {
      columnProps: { flexGrow: 1 },
      header: '预约时间',
      cell: <Cell dataKey="number" />,
    },
    {
      columnProps: { flexGrow: 1 },
      header: '客户名',
      cell: <UserNameCell dataKey="user_name" />,
    },
    {
      columnProps: { flexGrow: 1 },
      header: '手机尾号',
      cell: <Cell dataKey="phone" />,
    },
    {
      columnProps: { flexGrow: 1 },
      header: '所属购物村大使',
      cell: <Cell dataKey="ge_name" />,
    },
    {
      columnProps: { flexGrow: 1 },
      header: '所属导购大使',
      cell: <Cell dataKey="pcs_name" />,
    },
    {
      columnProps: { flexGrow: 1 },
      header: '备注',
      cell: <Cell dataKey="remark" />,
    },
    {
      columnProps: { flexGrow: 1 },
      header: '入场时间',
      cell: (
        <InsideCell
          dataKey="write_off_time"
          content="确认入场"
          handle={insideHandle}
          isHide={(rowData) => rowData?.isEdit}
        />
      ),
    },
  ];

  return (
    <div>
      <Panel dividerHeight={10} leftShadow title="导购大使预约查询">
        <FormikProvider value={formik}>
          <Form>
            <Card smDivider>
              <div className="inline-flex w-[70%] flex-1">
                <Card.Input label="手机号" formKey="phone" labelWeight={3} />
                <Card.Input label="会员号" formKey="user_code" labelWeight={3} />
                <Card.DateRangePicker label="预约日期" formKey="time_range" labelWeight={3} />
              </div>
              <IconButton type="submit" className="inline-flex items-center w-[30px] ml-[10px]">
                <Image src="/resources/images/match.svg" />
              </IconButton>
            </Card>
          </Form>
        </FormikProvider>
      </Panel>
      <Panel
        title={`${Bicester[profile?.shopping_village]} | 导购大使预约`}
        subTitle={`总计${total}条`}
        leftShadow
        style={{
          height:
            'max(calc(100vh - var(--headerHeight) - var(--navBarHeight) - var(--toolBarHeight) - 169px), auto)',
        }}
      >
        <Table
          loading={getListLoading}
          style={{
            height: `max(${
              useContentHeight({
                withToolBar: true,
                withPanelHeader: true,
                withPanelPaddingTop: true,
                withPanelPaddingBottom: true,
                withTablePagination: true,
              }) - 169
            }px, ${
              LAYOUT_CONFIG.TABLE_MIN_ROWS_WITH_HEADER_HEIGHT +
              LAYOUT_CONFIG.TABLE_PAGINATION_WITH_MARGIN_HEIGHT
            }px})`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          pageInfo={{
            page: current_page,
            total,
          }}
          className=""
          onChange={onChange}
          data={data}
          columns={columns}
        >
          <Table.Body
            height={Math.max(
              useContentHeight({
                withToolBar: true,
                withPanelHeader: true,
                withPanelPaddingTop: true,
                withPanelPaddingBottom: true,
                withTablePagination: true,
              }) - 169,
              LAYOUT_CONFIG.TABLE_MIN_ROWS_WITH_HEADER_HEIGHT
            )}
          />
          <Table.Pagination />
        </Table>
      </Panel>
    </div>
  );
};

export default Sa;
